// extracted by mini-css-extract-plugin
export default {"hostSelect__placeholder_text_color":"hostSelect-module__hostSelect__placeholder_text_color___e6iBY"};